import { useSectionsList } from '../api/hooks';
import Segmented from './ui/Segmented';

interface Props {
  grade: number | null;
  value: number | 'all';
  onChange: (next: number | 'all') => void;
  includeAll?: boolean;
  /** Only these section ids are offered (a teacher's own sections). */
  only?: number[] | null;
  'aria-label'?: string;
}

/** Section choice as a horizontal overflow-paging segmented control (design). */
export default function SectionPicker({
  grade, value, onChange, includeAll = true, only, 'aria-label': ariaLabel,
}: Props) {
  const q = useSectionsList(grade);
  const opts = [
    ...(includeAll ? [{ key: 'all', label: 'All' }] : []),
    ...(q.data?.sections ?? []).filter((s) => !only || only.includes(s.id)).map((s) => ({ key: String(s.id), label: s.name || s.display })),
  ];
  return (
    <Segmented scroll label={ariaLabel ?? 'Section'} value={value === 'all' ? 'all' : String(value)} options={opts}
      onChange={(k) => onChange(k === 'all' ? 'all' : Number(k))} />
  );
}
